import { atom } from 'jotai';
import type { FolderId, WorkspaceId, ViewModelId } from 'balus-common';

export const openWorkspaceIdsAtom = atom<Record<WorkspaceId, boolean>>({});

export const openFolderIdsAtom = atom<Record<FolderId, boolean>>({});

export const openViewModelIdsAtom = atom<Record<ViewModelId, boolean>>({});

export const toggleWorkspaceOpenAtom = atom(null, (get, set, workspaceId: WorkspaceId) => {
  const current = get(openWorkspaceIdsAtom);
  set(openWorkspaceIdsAtom, {
    ...current,
    [workspaceId]: !current[workspaceId],
  });
});

export const toggleFolderOpenAtom = atom(null, (get, set, folderId: FolderId) => {
  const current = get(openFolderIdsAtom);
  set(openFolderIdsAtom, {
    ...current,
    [folderId]: !current[folderId],
  });
});

export const toggleViewModelOpenAtom = atom(null, (get, set, viewModelId: ViewModelId) => {
  const current = get(openViewModelIdsAtom);
  set(openViewModelIdsAtom, {
    ...current,
    [viewModelId]: !current[viewModelId],
  });
});

export const resetOpenStateAtom = atom(null, (get, set) => {
  set(openWorkspaceIdsAtom, {});
  set(openFolderIdsAtom, {});
  set(openViewModelIdsAtom, {});
});

export const openWorkspaceAtom = atom(null, (get, set, workspaceId: WorkspaceId) => {
  set(openWorkspaceIdsAtom, (prev) => ({ ...prev, [workspaceId]: true }));
});

export const openFoldersAtom = atom(null, (get, set, payload: { folderIds: FolderId[]; workspaceId: WorkspaceId }) => {
  const { folderIds, workspaceId } = payload;
  set(openWorkspaceIdsAtom, (prev) => ({ ...prev, [workspaceId]: true }));
  const newFolderIds = folderIds.reduce(
    (acc, folderId) => {
      acc[folderId] = true;
      return acc;
    },
    {} as Record<FolderId, boolean>
  );
  set(openFolderIdsAtom, (prev) => ({
    ...prev,
    ...newFolderIds,
  }));
});
